<template>
  <div>
    <review-list :service_providers_id="serviceProvidersIds[0]" :isMainHeader="true" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import ReviewList from '@/components/Reviews';

export default {
  name: 'account-reviews',
  components: {
    ReviewList,
  },
  computed: {
    ...mapGetters('account/pro', ['serviceProvidersIds']),
  },
};
</script>
